






































import { Component, Prop, Watch } from "vue-property-decorator";
import { WorkerDetailsModule } from "@/store/modules/workerDetails";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import WorkerQualificationDto from "@/models/WorkerQualifications/WorkerQualificationDto";
import WorkerQualificationStatus from "@/models/WorkerQualifications/WorkerQualificationStatus";

@Component({
  name: "WorkerQualificationEdit",
})
export default class extends GiganautVueDialog {
  
  public dialog = false;

  @Prop({required: true})
  workerQualificationId: string;
  workerQualification: WorkerQualificationDto = new WorkerQualificationDto();
  isVerified = false;

  
 @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      //We need to fetch the latest copy - passing this in as a prop means updated at becomes stale on send edit
      const workerQualification = WorkerDetailsModule.qualifications.find((findWorkerQualification: WorkerQualificationDto) => findWorkerQualification.id === this.workerQualificationId);
      this.workerQualification = this.workerQualification = JSON.parse(JSON.stringify(workerQualification));
      this.isVerified = (this.workerQualification.status === WorkerQualificationStatus.Verified);
    }
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    if (this.isVerified) {
      this.workerQualification.status = WorkerQualificationStatus.Verified;
    } else {
      this.workerQualification.status = WorkerQualificationStatus.Pending;
    }
    await WorkerDetailsModule.editQualification(this.workerQualification);
    this.dialog = false;
  }
}
